import { createContext } from "react";

interface ModeContextInterface {
  adminMode: boolean;
  mentorMode: boolean;
  starterMode: boolean;
  handleChangeAdminMode: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const ModeContext = createContext({} as ModeContextInterface);

